import React from 'react';
import { useAuth } from '../context/AuthContext';

const features = [
  { icon: '✂️', title: 'Timeline Editor', desc: 'Cut and arrange clips on a precise, responsive timeline.' },
  { icon: '🎞️', title: 'Scene Library', desc: 'Keep every clip and take organized and easy to find.' },
  { icon: '⚡', title: 'Quick Export', desc: 'Render your project in the format you need, fast.' },
  { icon: '🎨', title: 'Color Grade', desc: 'Fine-tune the look and feel of every shot.' },
];

function greeting() {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
}

export default function Home() {
  const { user, isAuthenticated } = useAuth();

  return (
    <div className="min-h-screen" style={{ background: 'var(--brand-bg)' }}>
      <section className="border-b border-slate-200/60">
        <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 lg:px-8">
          <p className="text-xs font-black uppercase tracking-widest text-[var(--brand-primary-dark)]">
            {isAuthenticated ? `${greeting()}, ${user?.name || user?.email || 'Editor'}` : 'KinetoCut'}
          </p>
          <h1 className="mt-2 text-3xl font-black text-slate-900 sm:text-4xl">
            Precision Video Editing
          </h1>
          <p className="mt-3 max-w-xl text-sm text-slate-500 sm:text-base">
            A fast, focused workspace for cutting, arranging, and exporting your footage.
          </p>
        </div>
      </section>

      <main className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((f) => (
            <div key={f.title} className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
              <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl text-xl" style={{ background: 'var(--brand-bg)' }}>
                {f.icon}
              </div>
              <p className="font-black text-slate-900">{f.title}</p>
              <p className="mt-1 text-sm leading-relaxed text-slate-500">{f.desc}</p>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
